import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
} from "async-ops";
import { ALL } from "../../../reducers/ea-dashboard-reducer";
import { GET_TOTAL_AND_REJECTED_SUBMISSIONS_DATA } from "../services/get-total-and-rejected-submissions-data";
export const SET_WIDGET_VALUE = "SET_WIDGET_VALUE";

const initialState = {
    isLoading: false,
    totalAndRejectedSubmissionsList: [],
    chartDataSource: [],
    reviewContractors: []
};

export default function (state = initialState, action) {
    let newState;
    switch (action.type) {
        case SET_WIDGET_VALUE:
            newState = { ...state };
            newState = {
                ...newState,
                reviewContractorId: action.data.reviewContractorId,
                timePeriod: action.data.timePeriod,
                toggleValue: action.data.toggleValue
            };
            return newState;
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
            if (isAsyncOperation(GET_TOTAL_AND_REJECTED_SUBMISSIONS_DATA)(action)) {
                return { ...state, totalAndRejectedSubmissionsList: [],reviewContractors: [] };
            }
            if (isAsyncComplete(GET_TOTAL_AND_REJECTED_SUBMISSIONS_DATA)(action)) {
                var response = action.response;
                var activeReviewContractor = response?.reviewContractorDto?.length>0 ? response.reviewContractorDto?.filter(x=>x):[];
                activeReviewContractor.unshift(ALL);
                return { ...state, totalAndRejectedSubmissionsList: response.totalFilesSubmitted,reviewContractors: activeReviewContractor };
            }
            return state;
        default:
            return state;
    }
}